import { Text, CollapsibleSection, Flex } from '@sequencehq/core-components'
import { CustomerAddressFields } from '../components/CustomerAddressFields'
import { CustomerFormFieldControls } from '../types'
import { useSectionExpansion } from '../useSectionExpansion'
import { fieldStyles } from './styles'

export type BillingInformationSectionProps = {
  /** The address field controls — pass the hook's `fields` directly. */
  addressFields: Pick<
    CustomerFormFieldControls,
    | 'address.country'
    | 'address.line1'
    | 'address.line2'
    | 'address.town'
    | 'address.state'
    | 'address.postcode'
  >
  'data-testid'?: string
}

export const BillingInformationSection = ({
  addressFields,
  'data-testid': testId
}: BillingInformationSectionProps) => {
  const { isOpen, onToggle } = useSectionExpansion(
    Object.values(addressFields).some(
      field => field.validationErrors.length > 0
    )
  )

  return (
    <CollapsibleSection
      title="Billing information"
      isOpen={isOpen}
      onToggle={onToggle}
      data-testid={testId}
    >
      <Flex direction="column" gap="8px">
        <Text {...fieldStyles.label}>Billing details</Text>
        <CustomerAddressFields
          data-testid={testId ? `${testId}.address` : undefined}
          fields={{
            country: addressFields['address.country'],
            line1: addressFields['address.line1'],
            line2: addressFields['address.line2'],
            town: addressFields['address.town'],
            state: addressFields['address.state'],
            postcode: addressFields['address.postcode']
          }}
        />
      </Flex>
    </CollapsibleSection>
  )
}
